/*
  Buy box behaviour, wherever the theme's product form renders (pairs with
  nn-ui.css):

  1. Quantity stepper. The −/+ buttons write straight into the theme's own
     hidden [data-quantity-input] (name="quantity"), which is what the form
     submits, so Empire's add-to-cart path is untouched.
  2. Add to cart label follows the Groovy Subscriptions widget: "Subscribe &
     save — $33.20" or "Add to cart — $34.95", times the quantity. Read-only on
     the widget: it only looks at which option is active and that option's
     price. Products without the widget keep the stock label.
  3. Adding state. The Groovy widget currently lets the form submit as a
     plain page post to /cart (so Empire's spinner and popup never run) and
     the button sat dead for 1-2 s. On click we show the theme's own spinner
     ("processing") and lock the button, unless Empire is already handling it.
     Cleared by Empire when it finishes, on back/forward (bfcache) and after
     10 s as a safety net.
*/
(function () {
  var MAX_QTY = 99;

  function formOf(el) {
    return el.closest('form') || document;
  }

  function qtyInput(form) {
    return form.querySelector('.nn-atc [data-quantity-input]');
  }

  function updateLabel(form) {
    var btn = form.querySelector('.nn-atc .product-form--atc-button');
    if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
    var text = btn.querySelector('.atc-button--text');
    var active = form.querySelector('.groovy-group-active');
    if (!text || !active) return;
    var priceEl = active.querySelector('.groovy-price-wrap');
    var raw = priceEl ? priceEl.textContent.trim() : '';
    var match = raw.match(/[\d,]+(?:\.\d+)?/);
    if (!match) return;
    var unit = parseFloat(match[0].replace(/,/g, ''));
    var input = qtyInput(form);
    var qty = Math.max(1, parseInt(input && input.value, 10) || 1);
    var symbol = raw.slice(0, raw.indexOf(match[0])) || '$';
    var verb = active.classList.contains('groovy-plan-one-time-purchase') ? 'Add to cart' : 'Subscribe & save';
    var label = verb + ' — ' + symbol + (unit * qty).toFixed(2);
    if (text.textContent.trim() !== label) text.textContent = label;
  }

  function setQty(form, value) {
    var input = qtyInput(form);
    if (!input) return;
    var qty = Math.min(MAX_QTY, Math.max(1, value));
    input.value = qty;
    var select = form.querySelector('.nn-atc [data-quantity-select]');
    if (select && qty <= 9) select.value = String(qty);
    var stepper = form.querySelector('[data-nn-qty]');
    if (stepper) {
      stepper.querySelector('[data-nn-qty-value]').textContent = qty;
      stepper.querySelector('[data-nn-qty-step="-1"]').disabled = qty <= 1;
      stepper.querySelector('[data-nn-qty-step="1"]').disabled = qty >= MAX_QTY;
    }
    updateLabel(form);
  }

  // Cart line: drive the theme's own fields and let Empire's cart page do the
  // update. It reads whichever field is .visible (select below 10, input from
  // 10), so keep that pair in step, then fire change on the input, which is
  // what its handler listens to.
  function setCartQty(stepper, value) {
    var row = stepper.closest('[data-quantity-wrapper]');
    var input = row && row.querySelector('[data-quantity-input]');
    var select = row && row.querySelector('[data-quantity-select]');
    if (!input) return;
    var qty = Math.min(MAX_QTY, Math.max(1, value));
    input.value = qty;
    if (select && qty <= 9) select.value = String(qty);
    var useSelect = select && qty <= 9;
    [[select, useSelect], [input, !useSelect]].forEach(function (pair) {
      var field = pair[0] && pair[0].closest('.form-field');
      if (!field) return;
      field.classList.toggle('visible', pair[1]);
      field.classList.toggle('hidden', !pair[1]);
    });
    stepper.querySelector('[data-nn-qty-value]').textContent = qty;
    stepper.querySelector('[data-nn-qty-step="-1"]').disabled = qty <= 1;
    stepper.querySelector('[data-nn-qty-step="1"]').disabled = qty >= MAX_QTY;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-nn-qty-step]');
    if (!btn) return;
    event.preventDefault();
    var cartStepper = btn.closest('[data-nn-cart-qty]');
    if (cartStepper) {
      var shown = parseInt(cartStepper.querySelector('[data-nn-qty-value]').textContent, 10) || 1;
      setCartQty(cartStepper, shown + parseInt(btn.getAttribute('data-nn-qty-step'), 10));
      return;
    }
    var form = formOf(btn);
    var input = qtyInput(form);
    var current = parseInt(input && input.value, 10) || 1;
    setQty(form, current + parseInt(btn.getAttribute('data-nn-qty-step'), 10));
  });

  // The widget mounts after page load and re-renders on option/variant change,
  // and Empire rewrites the button text on variant change, so watch both.
  var pending = new WeakSet();
  function schedule(form) {
    if (pending.has(form)) return;
    pending.add(form);
    requestAnimationFrame(function () {
      pending.delete(form);
      updateLabel(form);
    });
  }

  function bind(widget) {
    if (widget.hasAttribute('data-nn-bound')) return;
    widget.setAttribute('data-nn-bound', '');
    var form = formOf(widget);
    var opts = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] };
    new MutationObserver(function () { schedule(form); }).observe(widget, opts);
    var btn = form.querySelector('.nn-atc .product-form--atc-button');
    if (btn) new MutationObserver(function () { schedule(form); }).observe(btn, opts);
    form.addEventListener('change', function () { schedule(form); });
    schedule(form);
  }

  function scan() {
    document.querySelectorAll('.groovy-widget:not([data-nn-bound])').forEach(bind);
  }

  var ADDING_TIMEOUT = 10000;

  function clearAdding(btn) {
    if (!btn.hasAttribute('data-nn-adding')) return;
    btn.removeAttribute('data-nn-adding');
    btn.removeAttribute('aria-busy');
    btn.classList.remove('processing');
    btn.disabled = false;
  }

  // Capture phase on window: the widget stops the click from bubbling.
  window.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.product-form--atc-button');
    if (!btn || btn.disabled || btn.classList.contains('disabled')) return;
    if (btn.type !== 'submit' || !btn.form) return;
    // Let the click submit first; locking the button inside the click handler
    // would cancel the submission.
    setTimeout(function () {
      if (btn.classList.contains('processing')) return; // Empire's AJAX add has it
      btn.setAttribute('data-nn-adding', '');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('processing');
      btn.disabled = true;
      setTimeout(function () { clearAdding(btn); }, ADDING_TIMEOUT);
    }, 0);
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-nn-adding]').forEach(clearAdding);
  });

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  scan();
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
